import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import { useMemoizeFeatureFlags } from '@atlaskit/media-common';
import Loadable from 'react-loadable';
import { CardLoading } from '../utils/lightCards/cardLoading';
var MediaCardContext = /*#__PURE__*/React.createContext({});
var CardLoadingWithContext = function CardLoadingWithContext() {
  var props = useContext(MediaCardContext);
  return /*#__PURE__*/React.createElement(CardLoading, props);
};
var MediaCard = Loadable({
  loader: function loader() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-card" */'./card').then(function (mod) {
      return mod.Card;
    });
  },
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CardLoadingWithContext, null);
  }
});
var MediaCardErrorBoundary = Loadable({
  loader: function loader() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-card-error-boundary" */'./media-card-analytics-error-boundary').then(function (mod) {
      return mod.default;
    });
  },
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CardLoadingWithContext, null);
  }
});
var MediaCardWithMediaClient = Loadable({
  loader: function loader() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-client" */'@atlaskit/media-client');
  },
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CardLoadingWithContext, null);
  },
  render: function render(loaded, props) {
    return /*#__PURE__*/React.createElement(CardWithMediaClient, _extends({}, props, {
      withMediaClient: loaded.withMediaClient
    }));
  }
});
var CardWithMediaClient = function CardWithMediaClient(props) {
  var withMediaClient = props.withMediaClient,
    dimensions = props.dimensions,
    featureFlags = props.featureFlags,
    onClick = props.onClick;
  var memoizedFeatureFlags = useMemoizeFeatureFlags(featureFlags);
  var Card = React.useMemo(function () {
    return withMediaClient(MediaCard, memoizedFeatureFlags);
  }, [withMediaClient, memoizedFeatureFlags]);
  return (
    /*#__PURE__*/
    // onClick is passed into MediaCardErrorBoundary so MediaGroup items can get the toolbar menu in Editor
    React.createElement(MediaCardErrorBoundary, {
      dimensions: dimensions,
      onClick: onClick
    }, /*#__PURE__*/React.createElement(Card, props))
  );
};
var CardLoader = function CardLoader(props) {
  return /*#__PURE__*/React.createElement(MediaCardContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(MediaCardWithMediaClient, props));
};
export default CardLoader;